import { render, staticRenderFns } from "./JoaDocReceivingList.vue?vue&type=template&id=061322e8&scoped=true&"
import script from "./JoaDocReceivingList.vue?vue&type=script&lang=js&"
export * from "./JoaDocReceivingList.vue?vue&type=script&lang=js&"
import style0 from "./JoaDocReceivingList.vue?vue&type=style&index=0&id=061322e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061322e8",
  null
  
)

export default component.exports